import type {
  ApiDashboardElement,
  ApiDashboardLayoutParametersType,
  ApiDashboardName,
  ApiReturnDashboard,
  ApiReturnSiteIdsToDashboardIds,
  AxesSelection,
  DashboardPublicLinkContext,
  DashboardPublicLinkResponse,
} from '@highimpact-frontend/api-types';
import { api_config } from '../../../api-commons';
import type { IDashboardService } from './IDashboardService';

class DashboardService implements IDashboardService {
  getSiteIdsToDashboardIds(): Promise<ApiReturnSiteIdsToDashboardIds> {
    return api_config
      .get('/sites/dashboards')
      .then((response) => response.data);
  }
  getDashboard(id: number): Promise<ApiReturnDashboard> {
    return api_config.get(`/dashboard/${id}`).then((response) => response.data);
  }
  postDashboard(params: ApiReturnDashboard): Promise<ApiReturnDashboard> {
    return api_config
      .post('/dashboard', params)
      .then((response) => response.data);
  }
  createPublicDashboard(
    dashboardId: number,
    context: DashboardPublicLinkContext
  ): Promise<string> {
    return api_config
      .post(`/dashboard/${dashboardId}/public-link`, context)
      .then(
        (response) => (response.data as DashboardPublicLinkResponse).public_url
      );
  }
  renameDashboard(
    id: number,
    data: ApiDashboardName
  ): Promise<ApiReturnDashboard> {
    return api_config
      .put(`/dashboard/${id}/name`, data)
      .then((response) => response.data);
  }
  renameWidget(
    dashboardId: number,
    widgetId: number,
    data: ApiDashboardName
  ): Promise<ApiReturnDashboard> {
    return api_config
      .put(
        `/dashboards/elements/${widgetId}/name?name=${encodeURIComponent(
          data.name
        )}`
      )
      .then((response) => response.data);
  }
  getDashboardElement(id: number): Promise<ApiDashboardElement> {
    return api_config
      .get(`/dashboards/elements/${id}`)
      .then((response) => response.data);
  }
  deleteDashboard(id: number): Promise<string> {
    return api_config
      .delete(`/dashboard/${id}`)
      .then((response) => response.data);
  }
  deleteDashboardWidget(id: number): Promise<string> {
    return api_config
      .delete(`/dashboards/elements/${id}`)
      .then((response) => response.data);
  }
  putDashboardLayout(
    dashboard_id: number,
    data: ApiDashboardLayoutParametersType
  ): Promise<string> {
    return api_config
      .put(`/dashboards/${dashboard_id}/layouts`, data)
      .then((response) => response.data);
  }
  postDashboardElement(
    dashboard_id: number,
    data: ApiDashboardElement
  ): Promise<number> {
    return api_config
      .post(`/dashboards/${dashboard_id}/elements`, data)
      .then((response) => response.data);
  }
  putDashboardElement(
    element_id: number,
    data: ApiDashboardElement
  ): Promise<ApiDashboardElement> {
    return api_config
      .put(`/dashboards/elements/${element_id}`, data)
      .then((response) => response.data);
  }
  updateAxisSelection(element_id: number, data: AxesSelection): Promise<void> {
    return api_config.put(`/dashboards/element/${element_id}/axes`, data);
  }
}

const service = new DashboardService();

export default service;
